import { ChangeDetectionStrategy, Component, ViewChild, output, input, effect, signal, Input } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { RouterModule } from '@angular/router';
import { SpeedDialModule } from 'primeng/speeddial';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule, Table } from 'primeng/table';
import { FilterMatchMode, FilterMetadata } from 'primeng/api';
import { OnActionEvent } from '../../models/pagination.abstract';

import { GetPathPipe } from '../../pipes/loadash-get.pipe';
import { MenuItem } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';

export interface PColumn {
  field: string;
  header: string;
  type?: 'text' | 'image' | 'tags' | 'actions';
}

@Component({
  selector: 'app-quick-table',
  imports: [
    CardModule,
    ButtonModule,
    SpeedDialModule,
    PaginatorModule,
    TableModule,
    RouterModule,
    GetPathPipe,
    InputTextModule,
    TagModule,
    SelectModule,
    MultiSelectModule,
  ],
  templateUrl: './quick-table.html',
  styleUrl: './quick-table.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class QuickTableComponent {
  // Inputs
  readonly columns = input<PColumn[]>([]);
  readonly tableData = input<any[]>([]); // This is the backup data
  // Default action is only select
  // readonly actions = input<MenuItem[]>();
  @Input() actions: MenuItem[] = [];

  // Outputs
  readonly onAction = output<OnActionEvent>();

  // Signals States
  public _columns = signal<PColumn[]>([]);
  public _tableData = signal<any[]>([]);
  public filters = signal<{ [s: string]: FilterMetadata | FilterMetadata[] }>({});
  public globalFilterFields = signal<string[]>([]);

  @ViewChild('tableRef') tableRef!: Table;

  tableColumns: any[] = [];

  constructor() {
    effect(() => {
      this.initializeTableColumns();
      if (this.tableData()) {
        this._tableData.set(this.tableData());

        this.initializeFilters();
      }
      if (!this.actions) {
        this.actions = [{ title: 'select', label: 'Select', icon: 'pi pi-check', severity: 'primary' }];
      }
      console.log('QuickTableComponent', this.actions);
    });
  }

  private initializeTableColumns(): void {
    if (!this.columns() || this.columns().length === 0) {
      console.warn('No columns provided. please privide columns for acuracy');
      if (this.tableData()?.[0]) {
        this.tableColumns = Object.keys(this.tableData()[0]).map((key) => ({
          field: key,
          header: key,
          sortable: true,
        }));
        console.log(this.tableColumns);
        this._columns.set(this.tableColumns);
      }
    } else {
      this._columns.set([...this.columns(), { field: 'actions', header: 'Actions', type: 'actions' }]);
    }
  }

  public selectItem(item: any, action: MenuItem) {
    console.log('onAction', { item, action });
    this.onAction.emit({ item, action: action.title || action.label });
  }

  public onGlobalFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.tableRef.filterGlobal(value, FilterMatchMode.CONTAINS);
  }

  public getFilterType(column: PColumn): string {
    if (column.type === 'image') {
      return 'text';
    }
    return 'text';
  }

  private initializeFilters(): void {
    // Initialize filters
    const filterObj: Record<string, any> = {};
    const fields: string[] = [];

    if (this._columns()) {
      this._columns().forEach((col) => {
        if (col.type === 'text') {
          // Add field to global filter fields
          fields.push(col.field);

          // Initialize filter for this column
          filterObj[col.field] = {
            value: null,
            matchMode: FilterMatchMode.CONTAINS,
          };
        } else if (col.type === 'tags') {
          // First extract all posible tags.
          console.log(this.tableData());
          const tags: string[] = [];
          this.tableData().forEach((item) => {
            if (Array.isArray(item[col.field])) {
              tags.push(...item[col.field]);
            } else {
              tags.push(item[col.field]);
            }
          });
          const uniqueTags = Array.from(new Set(tags));

          filterObj[col.field] = {
            value: null,
            matchMode: FilterMatchMode.IN,
            options: uniqueTags,
          };
        }
      });
    }

    this.filters.set(filterObj);
    this.globalFilterFields.set(fields);
  }

  public onFilterLocal(event: any) {
    console.log(event);
  }

  public filterOutsideTable(type: 'tags' | 'text', column: string, value: string[]) {
    // Its complicated understand all filter insde the table i can understand if i debugg tableRef.filters but seens is not able to filter array so i build my own outside.
    if (type === 'tags') {
      if (value.length === 0) {
        this._tableData.set(this.tableData());
        return;
      }
      const filteredData = [];
      this.tableData().forEach((item: string[]) => {
        if (Array.isArray(item[column])) {
          const tags: string[] = item[column];
          if (tags.some((tag) => value.includes(tag))) {
            filteredData.push(item);
          }
        }
      });
      console.log(filteredData);
      this._tableData.set(filteredData);
    }
  }
}
